//Author June Leow
//Date Mar 25th, 2024
import {getReducer, getSetStateFunction, deleteAPICallGenerator, callBackGenerator, generateTooltip, showMessage} from '../../../../util/util';
import {Card, CardHeader, CardBody, Col, Row, Input} from 'reactstrap';
import Compressor from 'compressorjs';
import Dropzone from 'react-dropzone'
import MySelect from '../../../util/my-select';
import React, {useReducer, useEffect} from 'react';
//initialize the state
const initialState = {

};


const locationEnum = [
  {value:'BORDERING_AMENITIES', label:'Bordering Amenities'}, 
  {value:'BORDERING_RAIL_STOP', label:'Bordering Rail Stop'}, 
  {value:'BORDERING_TROLLEY_STOP', label:'Bordering Trolley Stop'}, 
  {value:'BORDERING_CITY_BUS_STOP', label:'Bordering City Bus Stop'}, 
  {value:'BORDERING_BEACH', label:'Bordering Beach'}, 
  {value:'BORDERING_RECREATION', label:'Bordering Recreation'}, 
  {value:'GATED_COMMUNITY', label:'Gated Community'}, 
  {value:'OCEAN_FRONT_BEACH', label:'Ocean Front Beach'}, 
  {value:'OCEAN_FRONT_NO_BEACH', label:'Ocean Front No Beach'}, 
  {value:'INLAND_SALTWATER_FRONT_BEACH', label:'Inland Saltwater Front Beach'}, 
  {value:'INLAND_SALTWATER_FRONT_NO_BEACH', label:'Inland Saltwater Front No Beach'}, 
  {value:'LAKE_FRONT_BEACH', label:'Lake Front Beach'}, 
  {value:'LAKE_FRONT_NO_BEACH', label:'Lake Front No Beach'}, 
  {value:'SEASONAL_LAKE_FRONT', label:'Seasonal Lake Front'}, 
  {value:'RIVER_CANAL_FRONT', label:'River Canal Front'}, 
  {value:'BORDERING_GOLF_COURSE', label:'Bordering Golf Course'}, 
  {value:'GOLF_COURSE_COMMUNITY', label:'Golf Course Community'}, 
  {value:'RESIDENTIAL', label:'Residential'}, 
  {value:'BORDERING_INDUSTRIAL_USE', label:'Bordering Industrial Use'}, 
  {value:'BORDERING_COMMERCIAL_USE', label:'Bordering Commercial Use'}, 
  {value:'BORDERING_SCHOOL', label:'Bordering School'}, 
  {value:'BORDERING_VACANT_LAND', label:'Bordering Vacant Land'}, 
  {value:'BORDERING_HOSPITAL', label:'Bordering Hospital'}, 
  {value:'BORDERING_RESTAURANT', label:'Bordering Restaurant'}, 
  {value:'BORDERING_HOTEL_MOTEL_INN', label:'Bordering Hotel/Motel/Inn'}, 
  {value:'ON_CUL_DE_SAC_STREET', label:'On Cul De Sac Street'}, 
  {value:'ON_OR_BORDERING_BUSY_ROAD', label:'On Or Bordering Busy Road'}, 
  {value:'ON_OR_BORDERING_INTERSTATE_HWY', label:'On Or Bordering Interstate Highway'}, 
  {value:'AIR_TRAFFIC_DIRECTLY_OVERHEAD', label:'Air Traffic Directly Overhead'}, 
  {value:'BORDERING_PARK', label:'Bordering Park'}, 
  {value:'BORDERING_OVERHEAD_ELECTRIC_POWER_TRANSMISSION_LINE', label:'Bordering Overhead Electric Power Transmission Line'}, 
  {value:'BORDERING_LANDFILL', label:'Bordering Landfill'}, 
  {value:'NOTABLE_NOISE', label:'Notable Noise'}, 
  {value:'NOTABLE_ODOR', label:'Notable Odor'}, 
  {value:'OTHER_ADVERSE', label:'Other Adverse'}, 
  {value:'OTHER_BENEFICIAL', label:'Other Beneficial'}, 
  {value:'OTHER_NEUTRAL', label:'Other Neutral'}
];

const viewDescriptionTypeEnum = [
  {value:'NONE_NOTABLE', label:'None Notable'}, 
  {value:'VACANT_LOT', label:'Vacant Lot'}, 
  {value:'WOODS_TREED_PRIVATE', label:'Private Wood Treed'}, 
  {value:'HILLS_FOOTHILLS', label:'Hills/Foothills'}, 
  {value:'GREENBELT_OPEN_SPACE', label:'Greenbelt Open Space'}, 
  {value:'MOUNTAIN', label:'Mountain'}, 
  {value:'MOUNTAIN_RANGE', label:'Mountain Range'}, 
  {value:'POND', label:'Pond'}, 
  {value:'LAKE', label:'Lake'}, 
  {value:'CANAL', label:'Canal'}, 
  {value:'OCEAN', label:'Ocean'}, 
  {value:'RIVER', label:'River'}, 
  {value:'CREEK', label:'Creek'}, 
  {value:'BAY', label:'Bay'}, 
  {value:'SOUND', label:'Sound'}, 
  {value:'LAGOON', label:'Lagoon'}, 
  {value:'MARINA', label:'Marina'}, 
  {value:'INTRACOASTAL_WATERWAY', label:'Intercoastal Waterway'}, 
  {value:'HARBOR', label:'Harbor'}, 
  {value:'GULF', label:'Gulf'}, 
  {value:'WETLANDS', label:'Wetlands'}, 
  {value:'BAYOU', label:'Bayou'}, 
  {value:'MARSH', label:'Marsh'}, 
  {value:'COMMERCIAL', label:'Commercial'}, 
  {value:'PARKING_LOT', label:'Parking Lot'}, 
  {value:'INDUSTRIAL', label:'Industrial'}, 
  {value:'MILITARY_BASE', label:'Military Base'}, 
  {value:'RAILROAD', label:'Railroad'}, 
  {value:'INTERSTATE', label:'Interstate'}, 
  {value:'ELEVATED_OVERPASS', label:'Elevated Overpass'}, 
  {value:'PASTURES_FIELDS_ETC', label:'Pastures Fields ETC'}, 
  {value:'AGRICULTURAL_FARM_ETC', label:'Agricultural Farm ETC'}, 
  {value:'DESERT', label:'Desert'}, 
  {value:'CANYON', label:'Canyon'}, 
  {value:'VALLEY', label:'Valley'}, 
  {value:'COUNTRYSIDE', label:'Countryside'}, 
  {value:'RAVINE', label:'Ravine'}, 
  {value:'CITY_SKYLINE', label:'City Skyline'}, 
  {value:'GOLF_COURSE', label:'Golf Course'}, 
  {value:'PARK', label:'Park'}, 
  {value:'APARTMENT_COMPLEX', label:'Apartment Complex'}, 
  {value:'WINDMILL_WINDFARM', label:'Windmill Windfarm'}, 
  {value:'OVERHEAD_ELECTRIC_POWER_TRANSMISSION_LINE', label:'Overhead Electric Power Transmission Line'}, 
  {value:'SCHOOL', label:'School'}, 
];
const viewQualityEnum = [{value:'FULL',label:'Full'}, {value:'PARTIAL',label:'Partial'}]
const disabledStyling = {border:'none', background:'#fff', padding:'0',paddingLeft:'2px', height:'auto',WebkitAppearance:'none'};


//reducer function that perform state update
const reducer = getReducer();


const Locations  = (props)=>{
  const controller = new AbortController();

  const [, dispatch] = useReducer(reducer,initialState);

  //wrapper function
  const setState = getSetStateFunction(dispatch);

  const apiCallBack = callBackGenerator(setState);
  const httpDelete = deleteAPICallGenerator(props, {signal:controller.signal});

  //run only once when component is loaded
  useEffect(()=>{
    return ()=> controller.abort();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  //non API call but simpyl manage state
  const getCompressRatio=(size)=>{
    let ratio = 0.8;
    size = size/1000/1000;
  
    if(size>=20)
      ratio = 0.05;
    else if(size>=15)
      ratio = 0.05;
    else if(size>=10)
      ratio = 0.1;
    else if(size>=8)
      ratio = 0.2;
    else if(size>=6)
      ratio = 0.4;
    else if(size>=4)
      ratio = 0.5;
    else if(size>=3)
      ratio = 0.6;
    else if(size>=2)
      ratio = 0.7;
  
    return ratio;
  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop=(acceptedFiles, rejectedFiles, index, field, type='Misc', typeFk=0, description='')=>{

    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else if((acceptedFiles[i].size/1000/1000)<1){
          showMessage('error','Image quality is too low, please use photo that range from 1MB to 50MB.');
        }
        else if((acceptedFiles[i].size/1000/1000)>50){
          showMessage('error','Image size is too large, please use photo that range from 1MB to 50MB.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let newUPD = Object.assign({}, props.upd);
                let views = newUPD.property.site.siteFeature.siteView.views.slice()
   
                let target = views[index][field]?views[index][field]:[];
  
                target.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:views[index].ID, description:description});
                views[index][field] = target;
                newUPD.property.site.siteFeature.siteView.views = views;
                props.update(newUPD);
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  //function trigger for dropzone react.
  //this function contians two list of files, the accepted and rejected file per the configuration
  const onDrop2=(acceptedFiles, rejectedFiles, index, field, type='Misc', typeFk=0, description='')=>{
    let existingFiles = [];
    if(acceptedFiles.length>0){
      for(let i=0;i<acceptedFiles.length;i++){
        existingFiles.push(acceptedFiles[i]);
        let name = existingFiles[i].name;
        let token = name.split('.');
        let extension = '';

        if(token.length>0){
          extension = token[token.length-1];
          extension = extension.toLowerCase();
        }

        if(extension!=='png'&&extension!=='jpg'&&extension!=='jpeg'){
          showMessage('error','Please upload only PNG/JPG image.');
        }
        else if((acceptedFiles[i].size/1000/1000)<1){
          showMessage('error','Image quality is too low, please use photo that range from 1MB to 50MB.');
        }
        else if((acceptedFiles[i].size/1000/1000)>50){
          showMessage('error','Image size is too large, please use photo that range from 1MB to 50MB.');
        }
        else{
          let compressRatio = getCompressRatio(acceptedFiles[i].size);
          new Compressor(acceptedFiles[i], {
            quality: compressRatio, // 0.6 can also be used, but its not recommended to go below.
            success: (compressedResult) => {
              // compressedResult has the compressed file.
              // Use the compressed file to upload the images to your server.        
              let compressedFile = new File([compressedResult], acceptedFiles[i].name);

              const reader = new FileReader();
              reader.onload = () => {
                const fileAsBinaryString = reader.result;
                let base64 = btoa(fileAsBinaryString);
                let newUPD = Object.assign({}, props.upd);
                let locations = newUPD.property.site.siteFeature.location.locations.slice()
   
                let target = locations[index][field]?locations[index][field]:[];
  
                target.push({name:acceptedFiles[i].name, base64:base64, status:'Pending', size:compressedFile.size, type:type, typeFk:locations[index].ID, description:description});
                locations[index][field] = target;
                newUPD.property.site.siteFeature.siteView.locations = locations;
                props.update(newUPD);
              }
              reader.readAsBinaryString(compressedFile);
            },
          });
        }
      }
    }
  }

  const updateLocationDetail=(index, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let locations = newUPD.property.site.siteFeature.location.locations.slice()
    let target = locations[index]?locations[index]:[];
    target[field] = value;

    newUPD.property.site.siteFeature.siteView.locations = locations;
    props.update(newUPD);
  }

  const updateViewDetail=(index, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let locations = newUPD.property.site.siteFeature.location.locations.slice()
    let target = locations[index]?locations[index]:[];
    target[field] = value;

    newUPD.property.site.siteFeature.siteView.locations = locations;
    props.update(newUPD);
  }

  const updateFileDescription=(index, index2, field, description)=>{
    let newUPD = Object.assign({}, props.upd);
    let views = newUPD.property.site.siteFeature.siteView.views.slice()
    let target = views[index][field]?views[index][field]:[];
    if(target &&  target[index2]){
      target[index2].description = description;
    }

    newUPD.property.site.siteFeature.siteView.views = views;
    props.update(newUPD);
  }

  const updateFileDescription2=(index, index2, field, description)=>{
    let newUPD = Object.assign({}, props.upd);
    let locations = newUPD.property.site.siteFeature.location.locations.slice()
    let target = locations[index][field]?locations[index][field]:[];
    if(target &&  target[index2]){
      target[index2].description = description;
    }

    newUPD.property.site.siteFeature.siteView.locations = locations;
    props.update(newUPD);
  }

  const removeFile=(field,index, index2)=>{
    let newUPD = Object.assign({}, props.upd);
    let views = newUPD.property.site.siteFeature.siteView.views.slice()
    let target = views[index][field].slice();

    let targetToDelete = target[index2];

    if(targetToDelete.ID && targetToDelete.ID!==-1){
      let successCallBack = ()=>{
        target.splice(index2, 1);
        views[index][field] = target;
        newUPD.property.site.siteFeature.siteView.views = views;
        props.update(newUPD);
      };
      successCallBack = successCallBack.bind(this);
      deletePhoto(targetToDelete.ID, props, successCallBack);
    }
    else{
      target.splice(index2, 1);
      views[index][field] = target;
      newUPD.property.site.siteFeature.siteView.views = views;
      props.update(newUPD);
    }
  }

  const removeFile2=(field,index, index2)=>{
    let newUPD = Object.assign({}, props.upd);
    let locations = newUPD.property.site.siteFeature.location.locations.slice()
    let target = locations[index][field].slice();

    let targetToDelete = target[index2];

    if(targetToDelete.ID && targetToDelete.ID!==-1){
      let successCallBack = ()=>{
        target.splice(index2, 1);
        locations[index][field] = target;
        newUPD.property.site.siteFeature.location.locations = locations;
        props.update(newUPD);
      };
      successCallBack = successCallBack.bind(this);
      deletePhoto(targetToDelete.ID, props, successCallBack);
    }
    else{
      target.splice(index2, 1);
      locations[index][field] = target;
      newUPD.property.site.siteFeature.location.locations = locations;
      props.update(newUPD);
    }
  }

  const getLocationLabel=(location)=>{
    for(let i=0;i<locationEnum.length;i++){
      if(locationEnum[i].value===location)
        return locationEnum[i].label;
    }

    return location;
  }

  const getViewLabel=(view)=>{
    for(let i=0;i<viewDescriptionTypeEnum.length;i++){
      if(viewDescriptionTypeEnum[i].value===view)
        return viewDescriptionTypeEnum[i].label;
    }

    return view;
  }

  const updateLocation=(location)=>{
    let newUPD = Object.assign({}, props.upd);
    let locations = newUPD.property.site.siteFeature.location.locations.slice();

    locations.push({locationDescriptionType:location, locationDescriptionDetails:'', imageBorder:[], imageWaterFront:[]});
    newUPD.property.site.siteFeature.location.locations = locations;
    props.update(newUPD);
  }

  const updateView=(view)=>{
    let newUPD = Object.assign({}, props.upd);
    let views = newUPD.property.site.siteFeature.siteView.views.slice();
    
    if(view==='NONE_NOTABLE'){
      views = [{viewDescriptionType:view, viewQuality:'', viewDescriptionDetails:''}];
    }
    else{
      for(let i=0;i<views.length;i++){
        if(views[i].viewDescriptionType==='NONE_NOTABLE'){
          views = [];
          break;
        }
      }

      views.push({viewDescriptionType:view, viewQuality:'', viewDescriptionDetails:'', imageView:[]});
    }

    newUPD.property.site.siteFeature.siteView.views = views;
    props.update(newUPD);
  }

  const updateLocationDescription=(index, description)=>{
    let newUPD = Object.assign({}, props.upd);
    let locations = newUPD.property.site.siteFeature.location.locations.slice();
    locations[index].locationDescriptionDetails = description;

    newUPD.property.site.siteFeature.location.locations = locations;
    props.update(newUPD);
  }

  const updateViewDescription=(index, field, value)=>{
    let newUPD = Object.assign({}, props.upd);
    let views = newUPD.property.site.siteFeature.siteView.views.slice();
    views[index][field] = value;

    newUPD.property.site.siteFeature.siteView.views = views;
    props.update(newUPD);
  }

  const removeView=(index)=>{
    let newUPD = Object.assign({}, props.upd);
    let views = newUPD.property.site.siteFeature.siteView.views.slice();
    views.splice(index, 1);

    newUPD.property.site.siteFeature.siteView.views = views;
    props.update(newUPD);
  }

  const removeLocation=(index)=>{
    let newUPD = Object.assign({}, props.upd);
    let locations = newUPD.property.site.siteFeature.location.locations.slice();
    locations.splice(index, 1);

    newUPD.property.site.siteFeature.location.locations = locations;
    props.update(newUPD);
  }

  //API call
  const deletePhoto = (ID, props, successCallBack) => {
    let callBack = apiCallBack([],[()=>{successCallBack()}])
    httpDelete('uniformPropertyDataset/photo/'+ID, '', 'Oops, something went wrong and could not delete this photo. Please try again later.', callBack);
  }

  //render
  return <div>
    <label>{!props.disabled?<font color="red">*</font>:null}Location(s) {generateTooltip('locationDescriptionType', 'User to select the best option(s) to describe the most obvious aspect of the subject\'s location. Select them in order from most to least influential.')}</label>
    <MySelect
      type="select"
      required={!props.disabled}
      disabled={props.disabled}
      style={props.disabled?disabledStyling:{}}
      value={props.upd.property.site.siteFeature.location.locations && props.upd.property.site.siteFeature.location.locations.length>0?" ":""}
      onChange={(v)=>updateLocation(v)}
      options={locationEnum}
    />
    {
      props.upd.property.site.siteFeature.location.locations.map(
        (location, index)=>{
          return <Card key={index} style={{marginTop:'15px'}}>
            <CardHeader><i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeLocation(index)}/> {getLocationLabel(location.locationDescriptionType)}</CardHeader>
            <CardBody>
              <label>{!props.disabled?<font color="red">*</font>:null}Description</label>
              <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} type="text" value={location.locationDescriptionDetails} onChange={(e)=>updateLocationDescription(index,e.target.value)}/>

              <br/>
              {
                location.locationDescriptionType.includes('BORDERING')?<div>
                  <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of bordering influence</label>
                  <br/>
                  <input
                    tabIndex={-1}
                    autoComplete="off"
                    style={{ opacity: 0, height: 0, width:0 }}
                    value={location.imageBorder&&location.imageBorder.length>0?" ":""}
                    required={!props.disabled}
                  />
                  <div>
                    <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop2(accepted, rejected, index, 'imageBorder', 'BORDERING_INFLUENCE', 0)}} className="my-dropzone">
                    {
                      ({getRootProps, getInputProps}) => (
                        <div
                          {...getRootProps({
                            className: 'my-dropzone',
                          })}
                        >
                          <input {...getInputProps()} />
                          <center>Choose files to upload</center>
                        </div>
                      )
                    }
                    </Dropzone>
                    {
                      !location.imageBorder?null:location.imageBorder.map(
                        (photo, index2)=>{
                          return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                            <div>
                              <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile2('imageBorder',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                            </div>
                            <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                            {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription2(index, index2, 'imageBorder', e.target.value)}/>
                            <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                          </div>
                        }
                      )
                    }
                  </div>
                </div>:null
              }
              {
                location.locationDescriptionType==='RIVER_CANAL_FRONT'||location.locationDescriptionType==='LAKE_FRONT_NO_BEACH'||location.locationDescriptionType==='LAKE_FRONT_BEACH'||location.locationDescriptionType==='INLAND_SALTWATER_FRONT_NO_BEACH'||location.locationDescriptionType==='INLAND_SALTWATER_FRONT_BEACH'||location.locationDescriptionType==='OCEAN_FRONT_NO_BEACH'||location.locationDescriptionType==='OCEAN_FRONT_BEACH'?<div>
                  <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of water frontage</label>
                  <br/>
                  <input
                    tabIndex={-1}
                    autoComplete="off"
                    style={{ opacity: 0, height: 0, width:0 }}
                    value={location.imageWaterFront&&location.imageWaterFront.length>0?" ":""}
                    required={!props.disabled}
                  />
                  <div>
                    <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop2(accepted, rejected, index, 'imageWaterFront', 'WATERFRONT', 0)}} className="my-dropzone">
                    {
                      ({getRootProps, getInputProps}) => (
                        <div
                          {...getRootProps({
                            className: 'my-dropzone',
                          })}
                        >
                          <input {...getInputProps()} />
                          <center>Choose files to upload</center>
                        </div>
                      )
                    }
                    </Dropzone>
                    {
                      !location.imageWaterFront?null:location.imageWaterFront.map(
                        (photo, index2)=>{
                          return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                            <div>
                              <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile2('imageWaterFront',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                            </div>
                            <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                            {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription2(index, index2, 'imageWaterFront', e.target.value)}/>
                            <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                          </div>
                        }
                      )
                    }
                  </div>
                </div>:null
              }
            </CardBody>
          </Card>
        }
      )
    }
    <br/>
    {props.upd.property.propertyType==='SF'?<div>
      <label>{!props.disabled?<font color="red">*</font>:null}What, if anything, is the most notable thing viewed from the subject property? {generateTooltip('locationViewType', 'User to select the best option(s) to describe the subject\'s view. If there is no notable view or if all that is seen from the subject property is surrounding homes, then select the \'None Notable\' option.')}</label>
      <MySelect
        type="select"
        required={!props.disabled}
        disabled={props.disabled}
        style={props.disabled?disabledStyling:{}}
        value={props.upd.property.site.siteFeature.siteView.views && props.upd.property.site.siteFeature.siteView.views.length>0?" ":""}
        onChange={(v)=>updateView(v)}
        options={viewDescriptionTypeEnum}
      />

      {
        props.upd.property.site.siteFeature.siteView.views.map(
          (view, index)=>{
            if(view.viewDescriptionType==='NONE_NOTABLE'){
              return <div key={index} style={{marginTop:'15px'}}>
                <b>None Notable</b>
              </div>
            }
            else
              return <Card key={index} style={{marginTop:'15px'}}>
                <CardHeader><i className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeView(index)}/> {getViewLabel(view.viewDescriptionType)}</CardHeader>
                <CardBody>
                  <Row>
                    <Col sm="3">
                      <label>{!props.disabled?<font color="red">*</font>:null}View Quality {generateTooltip('viewQuality'+index, 'For each view selected the user is to select the best option to further describe the selected view. Full = Full view should be selected if it is a generally unobstructed view. Partial = Partial view should be selected if it is a significantly obstructed or limited view.')}</label>
                      <MySelect
                        type="select"
                        required={!props.disabled}
                        disabled={props.disabled}
                        style={props.disabled?disabledStyling:{}}
                        value={view.viewQuality}
                        onChange={(v)=>updateViewDescription(index, 'viewQuality', v)}
                        options={viewQualityEnum}
                      />
                    </Col>
                    <Col sm="3">
                    <label>{!props.disabled?<font color="red">*</font>:null}View Description Detail</label>
                      <Input style={props.disabled?disabledStyling:{}} disabled={props.disabled} required={!props.disabled} type="text" value={view.viewDescriptionDetails} onChange={(e)=>updateViewDescription(index,'viewDescriptionDetails', e.target.value)}/>
                    </Col>
                  </Row>
                  <br/>
                  <label>{!props.disabled?<font color="red">*</font>:null}Image(s) of notable view(s)</label>
                  <br/>
                  <input
                    tabIndex={-1}
                    autoComplete="off"
                    style={{ opacity: 0, height: 0, width:0 }}
                    value={view.imageView&&view.imageView.length>0?" ":""}
                    required={!props.disabled}
                  />
                  <div>
                    <Dropzone hidden={props.disabled} onDrop={(accepted, rejected)=>{onDrop(accepted, rejected, index, 'imageView', 'SF_VIEW', 0)}} className="my-dropzone">
                    {
                      ({getRootProps, getInputProps}) => (
                        <div
                          {...getRootProps({
                            className: 'my-dropzone',
                          })}
                        >
                          <input {...getInputProps()} />
                          <center>Choose files to upload</center>
                        </div>
                      )
                    }
                    </Dropzone>
                    {
                      !view.imageView?null:view.imageView.map(
                        (photo, index2)=>{
                          return <div key={index2} className="display-inline" style={{width:200, height:270, margin:5, verticalAlign:'top'}}>
                            <div>
                              <i hidden={props.disabled} className="fa fa-times red-color cursor-pointer" onClick={(e)=>removeFile('imageView',index, index2)}/> {photo.name.length>16?photo.name.substr(0,16)+'...':photo.name}
                            </div>
                            <img alt="pic" width="200" height="200" src={photo.status==='Pending'?"data:image/png;base64, "+photo.base64:photo.presign_url}/>
                            {!photo.ID?<div><Input type="text" placeholder="Description of photo" value={photo.description} onChange={(e)=>updateFileDescription(index, index2, 'imageView', e.target.value)}/>
                            <div style={{marginTop:'5px'}}/></div>:<i>{photo.description}</i>}
                          </div>
                        }
                      )
                    }
                  </div>
                </CardBody>
              </Card>
          }
        )
      }
    </div>:null}
  </div>
}


export default Locations;